import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { isUploadImageOverLimitError } from '../../util/errors';
import { isMobileSafari } from '../../util/userAgent';
import { formatMoney } from '../../util/currency';
import {
  FieldTextInput,
  Form,
  InfoTipForFields,
  IconDelete,
  EditListingWizardButtons,
  FieldSelect,
  FieldCurrencyInput,
  TextEditor
} from '../../components';
import { maxLength, required, composeValidators, moneySubUnitAmountAtLeast } from '../../util/validators';
import { types as sdkTypes } from '../../util/sdkLoader';
import arrayMutators from 'final-form-arrays';
import BackgroundPhoto from './BackgroundPhoto';
import PortfolioPhoto from './PortfolioPhoto';
import AddIcon from '@mui/icons-material/Add';

import FilesField from './FilesField';
import { getListingValuesBeforeUpdate } from '../../containers/EditListingPage/utils';


import css from './EditListingOfferDescriptionForm.module.css';
const TITLE_MAX_LENGTH = 60;
const ACCEPT_IMAGES = 'image/*';
const { Money } = sdkTypes;

export class EditListingOfferDescriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUploadRequested: false,
      showCrop: false,
      initialImages: [],
      showVideosForm: false,
      activeVideoIndex: 0,
    };
    this.onImageUploadHandler = this.onImageUploadHandler.bind(this);
    this.handleSubmitFile = this.handleSubmitFile.bind(this);
    this.submittedImages = [];
    this.isMobSaf = false;
  }

  componentDidMount() {
    this.isMobSaf = isMobileSafari();
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  componentDidUpdate(prevProps) {
    const { images } = this.props;

    if (this.compareImages()) {
      this.handleImages(images)
    }
  }

  imageIds(images) {
    return images &&
      images.length &&
      images
        .filter(image => image && (image.imageId || image.id && typeof image.id === 'object'))
        .map(image => image.imageId && image.imageId.uuid || image.id && image.id.uuid) || [];
  }

  handleImages(images) {
    const initialImages = this.imageIds(images);

    this.setState(
      { initialImages },
    )
  }

  onImageUploadHandler(file, imageKey) {
    const { onImageUpload, listing, handleSetFirstImage } = this.props

    if (file) {
      this.setState({ imageUploadRequested: true });
      onImageUpload({ id: `${Math.random().toFixed(4)}_${file.name}_${Date.now()}`, file, imageKey, listingId: listing?.id?.uuid })
        .then((res) => {
          this.setState({ imageUploadRequested: false });
          return res
        })
        .then((res) => {
          if (imageKey === "backgroundPhoto") {
            handleSetFirstImage({
              id: `${Math.random().toFixed(4)}_${file.name}_${Date.now()}`,
              file,
              imageId: res?.data?.data,
            })
          }
          return res
        })
        .catch(() => {
          this.setState({ imageUploadRequested: false });
        });
    }
  }

  compareImages() {
    const { images } = this.props;
    const { initialImages } = this.state;
    const prepearedImages = this.imageIds(images);

    return !isEqual(prepearedImages, initialImages);
  }

  handleSubmitFile(file, imageKey) {
    this.onImageUploadHandler(file, imageKey);
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        onImageUploadHandler={this.onImageUploadHandler}
        imageUploadRequested={this.state.imageUploadRequested}
        initialValues={{
          images: this.props.images,
          ...this.props.initialValues,
        }}
        render={formRenderProps => {
          const {
            className,
            fetchErrors,
            isAdmin,
            userWebsite,
            ownListingDesc,
            neededUserParams,
            config,
            handleSubmit,
            images,
            imageUploadRequested,
            intl,
            invalid,
            onImageUploadHandler,
            onRemoveImage,
            disabled,
            ready,
            saveActionMsg,
            updated,
            updateInProgress,
            isClient,
            form,
            form: {
              mutators: { push },
            },
            values,
            listing,
            currentUser,
            firstImageFromState,
            isProvider,
            isDraftListing,
            onHandlePreviewPopup,
            onHandleCreateAndBublishListing,
            isNewListingFlow,

            onHandleValidatonPopup,
            publishSuccess,
            handleSetInitialValues,
            description,
            offerDescription

          } = formRenderProps;


          const { showCrop, showVideosForm, activeVideoIndex } = this.state;

          const titleRequiredMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.titleRequired',
          });
          const maxLengthMessage = intl.formatMessage(
            { id: 'EditListingOfferDescriptionForm.maxLength' },
            {
              maxLength: TITLE_MAX_LENGTH,
            }
          );
          const maxLength60Message = maxLength(maxLengthMessage, TITLE_MAX_LENGTH);

          const descriptionMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.description',
          });
          const descriptionPlaceholderMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.descriptionPlaceholder',
          });
          const descriptionRequiredMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.descriptionRequired',
          });

          const offerDescriptionMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.offerDescription',
          });
          const offerDescriptionPlaceholderMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.offerDescriptionPlaceholder',
          });
          const offerDescriptionRequiredMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.offerDescriptionRequired',
          });


          const { publishListingError, showListingsError, updateListingError, uploadImageError, createListingDraftError } =
            fetchErrors || {};
          const uploadOverLimit = isUploadImageOverLimitError(uploadImageError);

          let uploadImageFailed = null;

          if (uploadOverLimit) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadOverLimit" />
              </p>
            );
          } else if (uploadImageError) {
            uploadImageFailed = (
              <p className={css.error}>
                <FormattedMessage id="EditListingPhotosForm.imageUploadFailed.uploadFailed" />
              </p>
            );
          }

          // NOTE: These error messages are here since Photos panel is the last visible panel
          // before creating a new listing. If that order is changed, these should be changed too.
          // Create and show listing errors are shown above submit button

          // This error happens only on first tab (of EditListingWizard)

          const errorMessageUpdateListing = updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
            </p>
          ) : null;

          const errorMessageCreateListingDraft = createListingDraftError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
            </p>
          ) : null;

          const errorMessageShowListing = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
            </p>
          ) : null;

          const publishListingFailed = publishListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.publishListingFailed" />
            </p>
          ) : null;
          const showListingFailed = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPhotosForm.showListingFailed" />
            </p>
          ) : null;

          const submittedOnce = this.submittedImages.length > 0;
          // imgs can contain added images (with temp ids) and submitted images with uniq ids.
          const arrayOfImgIds = imgs =>
            imgs.map(i => (typeof i.id === 'string' ? i.imageId : i.id));
          const imageIdsFromProps = arrayOfImgIds(images);
          const imageIdsFromPreviousSubmit = arrayOfImgIds(this.submittedImages);
          const imageArrayHasSameImages = isEqual(imageIdsFromProps, imageIdsFromPreviousSubmit);
          const pristineSinceLastSubmit = submittedOnce && imageArrayHasSameImages;

          const submitReady = (updated && pristineSinceLastSubmit) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = disabled || submitInProgress || imageUploadRequested || ready;

          const classes = classNames(css.root, className);
          const publicData = listing?.attributes?.publicData;

          const imagesArray = !!values?.images?.length ? values.images : images;

          const firstImage = imagesArray.filter(
            img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-')
          );
          const newImages = imagesArray.filter(
            img => typeof img.id === 'string' && !img.id?.includes('backgroundPhoto-')
          );

          const savedImages = imagesArray.filter(img => !!img?.id?.uuid);
          const sortedImages = [...firstImage, ...savedImages, ...newImages];

          const onHandleAddVideo = () => {
            push(`videos`, { undefined }),
              this.setState({ showVideosForm: true }),
              this.setState({ activeVideoIndex: values?.videos?.length || 0 })
          }

          const logoField = isAdmin ? (
            <div onClick={() => handleSetInitialValues(values)}>
              <BackgroundPhoto
                key="BackgroundPhoto"
                showCrop={showCrop}
                isMobSaf={this.isMobSaf}
                form={form}
                publicData={publicData}
                images={sortedImages}
                intl={intl}
                imageUploadRequested={imageUploadRequested}
                onImageUploadHandler={onImageUploadHandler}
                onRemoveImage={onRemoveImage}
                handleSubmitFile={this.handleSubmitFile}
                handleCloseCropPopup={() => this.setState({ showCrop: false })}
                isOffer
              />
            </div>
          ) : null;

          const portfolioField = isAdmin ? (
            <PortfolioPhoto
              key="PortfolioPhoto"
              showCrop={showCrop}
              isMobSaf={this.isMobSaf}
              form={form}
              publicData={publicData}
              images={sortedImages}
              intl={intl}
              imageUploadRequested={imageUploadRequested}
              onImageUploadHandler={onImageUploadHandler}
              onRemoveImage={onRemoveImage}
              handleSubmitFile={this.handleSubmitFile}
              handleCloseCropPopup={() => this.setState({ showCrop: false })}
              values={values}
              handleSetInitialValues={handleSetInitialValues}

            />
          ) : null;

          const titleField = (
            <FieldTextInput
              id="title"
              name="title"
              className={css.title}
              type="text"
              label={isAdmin ? intl.formatMessage({
                id: 'EditListingOfferDescriptionForm.name',
              }) : "Product name"}
              placeholder={isAdmin ? intl.formatMessage({
                id: 'EditListingOfferDescriptionForm.namePlaceholder',
              }) : "Product name"}
              maxLength={TITLE_MAX_LENGTH}
              validate={composeValidators(required(titleRequiredMessage), maxLength60Message)}
              isRequired
            />
          );

          const priceRequired = required(
            intl.formatMessage({
              id: 'EditListingPricingForm.priceRequired',
            })
          );
          const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
          const minPriceRequired = moneySubUnitAmountAtLeast(
            intl.formatMessage(
              {
                id: 'EditListingPricingForm.priceTooLow',
              },
              {
                minPrice: formatMoney(intl, minPrice),
              }
            ),
            config.listingMinimumPriceSubUnits
          );

          const priceValidators = config.listingMinimumPriceSubUnits
            ? composeValidators(priceRequired, minPriceRequired)
            : priceRequired;
          const priceFieldMaybe = isAdmin ? null : (
            <FieldCurrencyInput
              id="price"
              name="price"
              className={css.infoField}
              label="Price"
              placeholder="Price"
              currencyConfig={config.currencyConfig}
              validate={priceValidators}
            />
          );

          const websiteField = isAdmin ? (
            <FieldTextInput
              id="website"
              name="website"
              className={css.infoField}
              type="text"
              label={intl.formatMessage({
                id: 'EditListingDescriptionForm.website',
              })}
              placeholder={'wwww.example.com'}
              validate={!isClient && composeValidators(required('You need to complete this field'))}
              isRequired={!isClient}
            />
          ) : null;

          const shortDescriptionField = (
            <FieldTextInput
              id="shortDescription"
              name="shortDescription"
              className={css.infoField}
              type="text"
              label={intl.formatMessage({
                id: 'EditListingOfferDescriptionForm.offerTagLine',
              })}
              tipId="EditListingDescriptionForm.shortDescriptionTip"
              placeholder={'Type here...'}
              validate={composeValidators(required('You need to complete this field'), maxLength('Maximum length is 50 characters', 50))}
              isRequired
            />
          );

          const descriptionField = isAdmin ? (
            // <FieldTextInput
            //   id="description"
            //   name="description"
            //   className={css.descriptionTextBox}
            //   type="textarea"
            //   label={descriptionMessage}
            //   placeholder={descriptionPlaceholderMessage}
            //   validate={composeValidators(required(descriptionRequiredMessage))}
            //   isRequired
            // />
            <Field
              id="description"
              name="description"
              label={descriptionMessage}
              placeholder={descriptionPlaceholderMessage}
              component={TextEditor}
              fieldValue={description}
              isRequired
            />
          ) : null;

          const offerDescriptionField = (
            // <FieldTextInput
            //   id="offerDescription"
            //   name="offerDescription"
            //   className={css.descriptionTextBox}
            //   type="textarea"
            //   label={offerDescriptionMessage}
            //   placeholder={offerDescriptionPlaceholderMessage}
            //   validate={composeValidators(required(offerDescriptionRequiredMessage))}
            //   isRequired
            //   />

            <Field
              id="offerDescription"
              name="offerDescription"
              label={isAdmin ? offerDescriptionMessage : "Product Description"}
              placeholder={isAdmin ? offerDescriptionPlaceholderMessage : "Product Description"}
              component={TextEditor}
              fieldValue={offerDescription}
              isRequired
            />
          );


          const docsUploadField = isAdmin ? (
            <FilesField
              key="offerFiles"
              fieldName='files'
              label='Documents'
              // isDocumentField
              tip={<InfoTipForFields tipId="EditListingDescriptionForm.documentTip" />}
              mutatorsPush={push}
              usePreviewIcon
            />
          ) : null;


          const uploadVideoField = isAdmin ? (
            <>
              <h2 className={css.dynamicItemTitle}>
                <span>
                  <FormattedMessage id="EditListingPhotosForm.youtubeTitle" />
                  <InfoTipForFields tipId="EditListingPhotosForm.youtubeTitleTip" />
                </span>
                <AddIcon className={css.addButton} onClick={() => onHandleAddVideo()} />
              </h2>

              <FieldArray name={`videos`}>
                {({ fields }) => {
                  return fields.map((name, index) => {
                    const isSelected = activeVideoIndex === index;
                    return (
                      <>
                        {showVideosForm && (
                          <div key={`${name}-${index}`}>
                            <div
                              className={classNames(css.dynamicFieldWrapper, {
                                [css.dynamicFieldWrapperActive]: isSelected,
                              })}
                            >
                              <div
                                className={css.closeIconWrapper}
                                onClick={() => {
                                  fields.remove(index);
                                }}
                              >
                                <IconDelete />
                              </div>

                              <label htmlFor={`${name}.link`}>
                                <FormattedMessage id="EditListingPhotosForm.youtubeMessage" />
                              </label>
                              <Field
                                name={`${name}.link`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingPhotosForm.youtubePlaceholder',
                                })}
                              />

                              <label htmlFor={`${name}.title`}>
                                <FormattedMessage id="EditListingPhotosForm.videoMessage" />
                              </label>
                              <Field
                                name={`${name}.title`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingPhotosForm.videoPlaceholder',
                                })}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    );
                  });
                }}
              </FieldArray>
            </>
          ) : null;

          let formFields = [
            titleField,
            priceFieldMaybe,
            websiteField,
            shortDescriptionField,
            descriptionField,
            offerDescriptionField,
            docsUploadField,
            uploadVideoField,
            logoField,
            portfolioField,
          ]

          const invalidValues = getListingValuesBeforeUpdate(currentUser, images, values, isClient, true, false, true);

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {errorMessageCreateListingDraft}
              {errorMessageUpdateListing}
              {errorMessageShowListing}

              {formFields}

              <EditListingWizardButtons
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
                saveActionMsg={saveActionMsg}
                isClient={isClient}
                isNewListingFlow={isNewListingFlow}
                isDescriptionTab
                isDraftListing={isDraftListing}
                onHandlePreviewPopup={onHandlePreviewPopup}
                listingData={{ values, images, isDescriptionTab: true }}
                listing={listing}
                values={values}
                imagesArray={images}
                invalidValues={invalidValues}
                onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
                onHandleValidatonPopup={onHandleValidatonPopup}
                publishSuccess={publishSuccess}
                isOffer
                isAdmin={isAdmin}
                userWebsite={userWebsite}
                ownListingDesc={ownListingDesc}
                neededUserParams={neededUserParams}
              />
            </Form>
          );
        }}
      />
    );
  }
}

EditListingOfferDescriptionForm.defaultProps = { fetchErrors: null, images: [] };

EditListingOfferDescriptionForm.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape.isRequired,
  onImageUpload: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  onRemoveImage: func.isRequired,
};

export default compose(injectIntl)(EditListingOfferDescriptionForm);
